export const getDialogStyles = (colors) => ({
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: colors.overlay,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 2000,
  },
  dialog: {
    backgroundColor: colors.surface,
    padding: '24px',
    borderRadius: '22px',
    maxWidth: '90%',
    width: '400px',
    boxShadow: colors.shadow,
    border: `1px solid ${colors.border}`,
  },
  topBar: {
    display: 'flex',
    justifyContent: 'end',
    gap: '6px',
    marginBottom: '12px',
    flexWrap: 'nowrap',
  },
  menuGrid: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  menuButton: {
    display: 'flex',
    alignItems: 'center',
    padding: '12px 14px',
    border: 'none',
    borderRadius: '12px',
    backgroundColor: colors.button,
    color: colors.buttonText,
    cursor: 'pointer',
    width: '100%',
    transition: 'background-color 0.2s, transform 0.2s',
    boxShadow: 'inset 0 0 0 1px rgba(255,255,255,0.03)',
  },
  primaryButton: {
    backgroundColor: colors.accent,
  },
  disabledButton: {
    opacity: 0.55,
    cursor: 'not-allowed',
  },
  menuIcon: {
    fontSize: '24px',
    marginRight: '16px',
    width: '24px',
    textAlign: 'center',
  },
  menuText: {
    fontSize: '16px',
    color: colors.buttonText,
    textAlign: 'left',
    flex: 1,
  },
  selectContainer: {
    marginBottom: '16px',
  },
  selectGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '12px',
    marginBottom: '16px',
  },
  selectLabel: {
    display: 'block',
    fontSize: '14px',
    color: colors.text,
    marginBottom: '6px',
    textAlign: 'left',
    fontWeight: '600',
  },
  select: {
    width: '100%',
    padding: '12px 14px',
    border: `2px solid ${colors.border}`,
    borderRadius: '12px',
    fontSize: '15px',
    backgroundColor: colors.surfaceElevated,
    color: colors.text,
    appearance: 'none',
    cursor: 'pointer',
    outline: 'none',
  },
  closeButton: {
    display: 'block',
    width: '100%',
    padding: '12px',
    border: 'none',
    borderRadius: '25px',
    cursor: 'pointer',
    fontSize: '16px',
    fontWeight: '500',
    backgroundColor: colors.surfaceElevated,
    color: colors.text,
    marginTop: '16px',
  },
  iconButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '40px',
    height: '40px',
    border: 'none',
    borderRadius: '14px',
    cursor: 'pointer',
    backgroundColor: colors.button,
    color: colors.buttonText,
    boxShadow: 'inset 0 0 0 1px rgba(255,255,255,0.03)',
    fontSize: '18px',
  },
  activeIconButton: {
    backgroundColor: colors.accent,
    color: colors.accentText,
  },
  statsPanel: {
    backgroundColor: colors.surfaceElevated,
    borderRadius: '14px',
    padding: '14px',
    marginBottom: '16px',
    border: `1px solid ${colors.border}`,
  },
  statsHeader: {
    fontSize: '13px',
    textTransform: 'uppercase',
    letterSpacing: '0.1em',
    opacity: 0.7,
    marginBottom: '10px',
    color: colors.text,
  },
  statsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '10px',
  },
  statCard: {
    backgroundColor: colors.surface,
    borderRadius: '12px',
    padding: '12px',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  statLabel: {
    fontSize: '11px',
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    opacity: 0.7,
    color: colors.text,
  },
  statValue: {
    fontSize: '18px',
    fontWeight: '700',
    color: colors.text,
  },
  statsFooter: {
    marginTop: '10px',
    fontSize: '12px',
    color: colors.text,
    opacity: 0.75,
    lineHeight: 1.4,
  },
  statusMessage: {
    marginTop: '14px',
    fontSize: '13px',
    color: colors.text,
    opacity: 0.75,
    textAlign: 'center',
  },
  creditLinks: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    marginTop: '14px',
    alignItems: 'center',
  },
  creditLink: {
    fontSize: '12px',
    color: colors.text,
    opacity: 0.72,
    textAlign: 'center',
    textDecoration: 'underline',
  },
  notificationRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
    marginTop: '12px',
    padding: '12px 14px',
    borderRadius: '12px',
    backgroundColor: colors.surfaceElevated,
    border: `1px solid ${colors.border}`,
  },
  notificationText: {
    fontSize: '14px',
    color: colors.text,
    opacity: 0.85,
  },
  notificationControls: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginTop: '10px',
  },
  timeInput: {
    flex: 1,
    minWidth: 0,
    padding: '10px 12px',
    border: `2px solid ${colors.border}`,
    borderRadius: '10px',
    fontSize: '14px',
    backgroundColor: colors.surfaceElevated,
    color: colors.text,
    outline: 'none',
  },
  secondaryMiniButton: {
    border: 'none',
    borderRadius: '10px',
    padding: '8px 12px',
    backgroundColor: colors.button,
    color: colors.buttonText,
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: '600',
  },
  subMenu: {
    backgroundColor: colors.button,
    padding: '16px',
    borderRadius: '12px',
    marginTop: '8px',
  },
  backButton: {
    display: 'flex',
    alignItems: 'center',
    padding: '12px 16px',
    border: 'none',
    borderRadius: '12px',
    backgroundColor: colors.surfaceElevated,
    color: colors.text,
    cursor: 'pointer',
    width: '100%',
    marginBottom: '16px',
  },
  step: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 0',
    fontSize: '16px',
    color: colors.text,
  },
  stepNumber: {
    width: '24px',
    height: '24px',
    borderRadius: '12px',
    backgroundColor: colors.border,
    color: colors.text,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '12px',
    fontSize: '14px',
  }
});
